import * as React from 'react';
// next
import NextLink from 'next/link';
// layouts
import Layout from '../layouts';
// componentes
import Page from '../components/Page';

// ----------------------------------------------------------------------
// Pagina 404 - migrada do MUI para o visual novo (tokens --gps-*).
//
// A ilustracao MUI (PageNotFoundIllustration) foi removida de proposito: o
// arquivo fonte (src/assets/illustration_404.jsx) e MUI puro e nao tem
// substituto no design novo. Um bloco tipografico com o codigo do erro cobre
// a mesma funcao (avisar e oferecer caminho de volta) sem arrastar MUI de
// volta para uma pagina que devia estar limpa.
// ----------------------------------------------------------------------

Page404.getLayout = function getLayout(page: React.ReactNode) {
  return <Layout variant="logoOnly">{page}</Layout>;
};

// ----------------------------------------------------------------------

export default function Page404() {
  return (
    <Page title="404 Pagina nao encontrada">
      <div className="flex min-h-full items-center justify-center bg-fundo px-4 py-24">
        <div className="mx-auto max-w-[480px] text-center">
          <span className="text-6xl font-extrabold tabular-nums text-faint">404</span>

          <h1 className="mt-3 text-xl font-extrabold tracking-[-0.02em] text-ink">
            Desculpe, pagina nao encontrada!
          </h1>

          <p className="mt-2 text-[12.5px] text-muted-foreground">
            Desculpe, nao conseguimos encontrar a pagina que voce esta procurando. Talvez voce tenha digitado
            incorretamente o URL? Certifique-se de verificar sua ortografia.
          </p>

          <NextLink
            href="/"
            className="mt-8 inline-flex h-10 items-center justify-center rounded-lg bg-primary px-5 text-[12.5px] font-bold text-primary-foreground no-underline"
          >
            Ir para Home
          </NextLink>
        </div>
      </div>
    </Page>
  );
}
